module.exports = __webpack_public_path__ + "static/img/DE.a85944b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/certified_shipping/DE.png
// module id = 0Xba
// module chunks = 2